// eslint-disable-next-line import/prefer-default-export
export function getMarkup(s) {
  return {
    __html: s,
  };
}
